"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBDropdownMenu;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * Global components
 * By Juan Magos <jmagossanche@svb.com> (www.svb.com)
 * Summary
 * This component renders a SVB button
 */

/**
 * SVBButton
 * @param {string} [label = ''] - Text displayed in the dropdown button
 * @param {string[]} [options = [{key: 1, value:'example'}]] - Array of objects of data options
 * @param {string[]} [defaultKeys = []] - Array of strings of default keys
 * @param {string} [type = 'search' | 'check' | ''] - Type of the dropdown
 * @param {string} [direction = 'top'] - Direction to display options (bottom is default)
 * @param {function} [onClick = () => console.log('No onClick function provided')] - Function to execute when an option is selected
 * @param {function} [onTyped = () => console.log('No onClick function provided')] - Function to execute when input in dropdown type search is typed
 * @returns JSX element
 */

function SVBDropdownMenu(props) {
  const [options, setOptions] = (0, _react.useState)([]);
  const [toggle, setToggle] = (0, _react.useState)(false);
  const [inputSearchValue, setInputSearchValue] = (0, _react.useState)('');
  const [selectedOption, setSelectedOption] = (0, _react.useState)(props !== null && props !== void 0 && props.defaultKeys ? props.type === 'check' ? props === null || props === void 0 ? void 0 : props.defaultKeys : props === null || props === void 0 ? void 0 : props.defaultKeys[0] : []);
  const [allChecked, setAllChecked] = (0, _react.useState)(false);
  const ref = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    var _props$options;
    if ((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.length) === (props === null || props === void 0 || (_props$options = props.options) === null || _props$options === void 0 ? void 0 : _props$options.length)) {
      setAllChecked(true);
      setToggle(true);
    } else {
      setAllChecked(false);
    }
    if (props !== null && props !== void 0 && props.onChange) {
      const selectedObjects = props.options.filter(option => selectedOption.indexOf(option.key) !== -1);
      props === null || props === void 0 ? void 0 : props.onChange(selectedObjects);
    }

    // props?.change(selectedOption);
  }, [selectedOption]);
  (0, _react.useEffect)(() => {
    var _props$options2;
    if (props.type === 'search' & ((_props$options2 = props.options) === null || _props$options2 === void 0 ? void 0 : _props$options2.length) > 0) {
      const filteredOptions = props.options.filter(option => {
        const optionValue = typeof option.value === 'string' ? option.value : option.value.props.children;
        return optionValue.includes(inputSearchValue);
      });
      setOptions(filteredOptions);
    } else {
      setOptions(props.options);
    }
  }, [inputSearchValue]);
  (0, _react.useEffect)(() => {
    const handleClickOutside = event => {
      if (ref.current && !ref.current.contains(event.target)) {
        setToggle(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside, true);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside, true);
    };
  }, [ref]);
  const handleSelectedOption = (e, option) => {
    e.stopPropagation();
    if (props.type === 'search') {
      if (typeof option.value === 'string') {
        setInputSearchValue(option.value);
      } else {
        setInputSearchValue(option.value.props.children);
      }
    }
    if (selectedOption.includes(option.key)) {
      const newArr = [...selectedOption];
      newArr.splice(newArr.indexOf(option.key), 1);
      setSelectedOption(newArr);
    } else {
      if (props.type === 'check') {
        setSelectedOption(lastValue => [...lastValue, option.key]);
      } else {
        setSelectedOption([option.key]);
      }
    }
  };
  const selectAllHandler = e => {
    e.stopPropagation();
    if (allChecked) {
      setSelectedOption([]);
    } else {
      setSelectedOption(props.options.map(option => option.key));
    }
    setAllChecked(!allChecked);
  };
  const handleInputSearch = e => {
    setInputSearchValue(e.target.value);
  };
  const setLabel = () => {
    if (props.label && selectedOption.length === 0) {
      return props.label;
    }
    if (props.label && selectedOption.length > 0 && props.type !== 'check') {
      var _props$options3;
      return (_props$options3 = props.options) === null || _props$options3 === void 0 || (_props$options3 = _props$options3.find(option => selectedOption.indexOf(option.key) !== -1)) === null || _props$options3 === void 0 ? void 0 : _props$options3.value;
    }
    if (!props.label && selectedOption.length === 0 && props.type !== 'check') {
      return 'Select an option';
    }
    if (!props.label && props.type === 'check' && selectedOption.length === 0) {
      return 'Multiple';
    }
    if (props.label && props.type === 'check' && selectedOption.length > 0) {
      return props.label;
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    ref: ref,
    className: "dropdown"
  }, props.type === 'search' ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("i", {
    className: "fa-solid fa-magnifying-glass dropdown__search-icon"
  }), /*#__PURE__*/_react.default.createElement("input", {
    className: "dropdown__search-input",
    type: "text",
    onChange: event => {
      if (props.onTyped) {
        props.onTyped(event.target.value);
      }
      handleInputSearch(event);
    },
    onFocus: () => {
      setToggle(true);
    },
    value: inputSearchValue
  })) : /*#__PURE__*/_react.default.createElement("button", {
    className: "dropdown__button",
    type: "button",
    onClick: () => setToggle(!toggle)
  }, props.type === 'check' && /*#__PURE__*/_react.default.createElement("input", {
    className: "dropdown__checkbox",
    type: "checkbox",
    onClick: selectAllHandler,
    value: "all",
    checked: allChecked,
    onChange: event => {
      if (process.env.NODE_ENV !== 'production') console.log('test');
    }
  }), setLabel(), (props === null || props === void 0 ? void 0 : props.direction) === 'top' ? /*#__PURE__*/_react.default.createElement("i", {
    className: "fa-solid fa-chevron-up dropdown__icon-chevron"
  }) : /*#__PURE__*/_react.default.createElement("i", {
    className: "fa-solid fa-chevron-down dropdown__icon-chevron"
  })), toggle && /*#__PURE__*/_react.default.createElement("ul", {
    className: "dropdown__menu ".concat(props.direction === 'top' ? 'top' : '')
  }, options ? options === null || options === void 0 ? void 0 : options.map(option => /*#__PURE__*/_react.default.createElement("li", {
    key: option.key,
    className: selectedOption.includes(option === null || option === void 0 ? void 0 : option.key) || allChecked ? 'selected' : '',
    onClick: e => handleSelectedOption(e, option)
  }, props.type === 'check' && /*#__PURE__*/_react.default.createElement("input", {
    className: "dropdown__checkbox",
    type: "checkbox",
    value: option.key,
    checked: selectedOption.includes(option === null || option === void 0 ? void 0 : option.key) || allChecked,
    onChange: e => handleSelectedOption(e, option)
  }), props.type === 'search' ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("i", {
    className: "fa-solid fa-magnifying-glass dropdown__item-searchIcon"
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "dropdown__item-search"
  }, option.value)) : /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown__item"
  }, option.value))) : null));
}